module.exports = __webpack_public_path__ + "static/speed-2-8c173e9099e53ab0d5fb5919af0aa552.png";